module.exports = __webpack_public_path__ + "img/1.60f760c.jpg";